module.exports = __webpack_public_path__ + "static/media/976a69a1.jpg";